import React, { useContext } from "react";
import { SettingsContext } from "./SettingsContext.tsx";
import { SelectButton } from "primereact/selectbutton";
import { RadioButton } from "primereact/radiobutton";
import { AVERAGE_LIST_LENGTH_OPTIONS, AverageQuestionOptions } from "../Constants.ts";
import { withLabels } from "../Labels.ts";
import { useTranslation } from "../../Shared/i18n/useTranslation.ts";

/**
 * The two averages dials (ADR 0039 §2).
 *
 * The operator bar is hidden for this format: a mean or median question has a
 * list, not two operands, and there is no operator between the values in it.
 */
export function AverageSettings() {
    const { settings, setSettings } = useContext(SettingsContext);
    const t = useTranslation();

    function handleQuestionChange(value: AverageQuestionOptions) {
        // SelectButton hands back null when the selected option is clicked
        // again; a sheet has to ask something.
        if (!value) {
            return;
        }
        setSettings({ ...settings, AverageQuestion: value });
    }

    function handleListLengthChange(event) {
        setSettings({ ...settings, AverageListLength: Number(event.target.value) });
    }

    return (
        <div className="averageSettingsContainer">
            <div className="regroupingContainer">
                <SelectButton
                    value={settings.AverageQuestion}
                    onChange={(e) => handleQuestionChange(e.value)}
                    options={withLabels(Object.values(AverageQuestionOptions), settings.Language)}
                    className="select regrouping"
                    aria-label={t('settings.questionType')}
                />
            </div>
            <div className="selectContainer">
                <span className="settingLabel">{t('settings.listLengthLabel')}</span>
            </div>
            <div className="radioButtons" role="radiogroup" aria-label={t('settings.listLengthAria')}>
                {AVERAGE_LIST_LENGTH_OPTIONS.map((option) => (
                    <div key={option}>
                        <RadioButton
                            inputId={`averageListLength-${option}`}
                            value={option}
                            checked={settings.AverageListLength === option}
                            onChange={handleListLengthChange}
                        />
                        <label htmlFor={`averageListLength-${option}`}>{option}</label>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default AverageSettings;
